var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.455 6.38a.94.94 0 0 1 0-.763L9.12 1.876C9.58.98 8.631.466 8.05.916c-1.077.836-3.804 3.352-5.039 4.5a.795.795 0 0 0 0 1.165c1.235 1.149 3.962 3.665 5.039 4.5.594.462 1.52-.08 1.071-.96z"
  })));
};
export default SvgArrowLeft;